import firebase from '../Firebase/Firebase';

const call = (name) => firebase.app().functions('europe-west1').httpsCallable(name);

export const migrateToTwoRootArchitecture = async () => (
  await call('migrateToTwoRootArchitecture')({})
).data;

export const verifyTwoRootArchitecture = async () => (
  await call('verifyTwoRootArchitecture')({})
).data;

export const cleanupLegacyRootCollections = async () => (
  await call('cleanupLegacyRootCollections')({ confirm: 'DELETE_LEGACY_ROOTS' })
).data;
